// extracted by mini-css-extract-plugin
export default {"box":"Card_box__L+hO2","image":"Card_image__jhrzo","content":"Card_content__F3Sky","heading":"Card_heading__TQ-Ul","text":"Card_text__3xhPq"};